import { render, staticRenderFns } from "./current-attachment-info.vue?vue&type=template&id=d604915e&scoped=true"
import script from "./current-attachment-info.vue?vue&type=script&lang=js"
export * from "./current-attachment-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_fa4cvkteopfvx2274rwhhr2idm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d604915e",
  null
  
)

export default component.exports